import { Scroll } from 'components/scroll'

export class VitrineObserver {
    constructor() {
        this.class = 'vitrine--opened'
    }

    next(vitrine) {
        vitrine.classList.toggle(this.class)
        new Scroll(vitrine.offsetTop + vitrine.querySelector('.vitrine__content-item').offsetHeight - 30, 300)
    }

    error(error) {

    }

    complete() {
        
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/vitrine/vitrine.observer.js